import { combineLatest, Subject, timer, filter, take } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';

import { PaymentService } from '@core/services/payment/payment.service';
import { PaymentStoreDispatcher } from '@common/dispatchers/payment.dispatcher';
import { DoodOrderModel } from '@store/order/order.model';
import { AnalyticsService } from '@core/services/app/analytics.service';
import { PaymentAtTableStoreSelector } from '@common/selectors/payment-at-table.selector';

@Component({
  selector: 'app-pat-payment-panel-lyf-pro-app',
  template: ` <div
    *ngIf="isUnique"
    class="absolute inset-0 z-100 flex h-screen items-center justify-center bg-white"
  >
    <div class="flex flex-col items-center justify-center gap-8 p-12">
      <i class="icon icon-privacy animate-pulse text-4xl"></i>
      <h1 class="text-center text-xl font-bold">Redirection vers la page de paiement...</h1>
    </div>
  </div>`,
})
export class PatPaymentPanelLyfProAppComponent implements OnInit, OnDestroy {
  @Input() isUnique = false;
  protected readonly unsubscribe$ = new Subject<boolean>();
  order: DoodOrderModel | null = null;

  constructor(
    private readonly paymentService: PaymentService,
    private paymentDispatcher: PaymentStoreDispatcher,
    private readonly analyticsService: AnalyticsService,
    private readonly paymentAtTableSelector: PaymentAtTableStoreSelector,
  ) {}

  ngOnInit(): void {
    // combineLatest([this.paymentService.pay$, this.paymentService.paymentLyfProAppIntent$])
    //   .pipe(
    //     takeUntil(this.unsubscribe$),
    //     skipWhile(([, paymentIntent]) => !paymentIntent),
    //     map(([, paymentIntent]) => {
    //       console.log('go to ', paymentIntent?.lyfproUrl);
    //       if (paymentIntent?.lyfproUrl) {
    //         console.log('GO TO LYF PRO');
    //         window.location.href = paymentIntent.lyfproUrl;
    //       } else {
    //         throw new Error('Payment intent is undefined');
    //       }
    //     }),
    //   )
    //   .subscribe();

    combineLatest([this.paymentService.pay$, this.paymentService.paymentLyfProAppIntent$])
      .pipe(
        takeUntil(this.unsubscribe$),
        filter(([pay, paymentIntent]) => pay === true && !!paymentIntent?.lyfproUrl),
        take(1),
        map(([_, paymentIntent]) => {
          if (paymentIntent) {
            // Get table information for partnerContext
            const check = this.paymentAtTableSelector.check;
            const tableId = check?.onsite_location?.id;
            const tableName = check?.onsite_location?.name;
            const timestamp = Date.now();

            // Build partnerContext parameter if table info is available
            let partnerContext = '';
            if (tableId && tableName) {
              partnerContext = `onSiteLocationId=${tableId}&onSiteLocationName=${tableName}&timestamp=${timestamp}`;
            }

            // Parse the URL and update parameters
            const url = new URL(paymentIntent.lyfproUrl);
            if (partnerContext) {
              url.searchParams.set('partnerContext', partnerContext);
            }

            const finalUrl = url.toString();

            console.log('GO TO LYF PRO', finalUrl);
            this.analyticsService.log({
              level: 'debug',
              label: '#DOOD-1250 Navigate',
              message: {
                from: 'PatPaymentPanelLyfProAppComponent Ligne°58',
                target: finalUrl,
                currentLocation: window.location.pathname,
                partnerContext: partnerContext || '',
              },
            });
            window.location.href = finalUrl;
          }
        }),
      )
      .subscribe();

    if (this.isUnique) {
      timer(1).subscribe(() => {
        this.paymentDispatcher.updateButton({
          text: "Redirection vers l'écran de paiement...",
        });
        this.paymentService.pay$.next(true);
      });
    }
  }

  ngOnDestroy(): void {
    this.paymentDispatcher.resetUI();
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }
}
